import {
  keepPreviousData,
  queryOptions,
  useQuery,
  type UseQueryResult,
} from '@tanstack/react-query'

import { eventsService } from '@/features/market-events/api/eventsService'
import { marketEventsKeys } from '@/features/market-events/api/keys'
import type { EventRow, EventsQuery } from '@/schemas/market-events'
import type { TablePage } from '@/schemas/table'

/**
 * The Market · Events calendar's server-paged view — the route's MAIN read (see
 * `EventsScreen.loader.ts`: the loader awaits it for the ENTRY URL's filters).
 */
export const marketEventsTableQueryOptions = (query: EventsQuery) =>
  queryOptions<TablePage<EventRow>>({
    queryKey: marketEventsKeys.table(query),
    queryFn: () => eventsService.table(query),
  })

/**
 * No polling, unlike Overview, Movers and the trade log: a book closure four
 * weeks out does not move during a session, and refetching it every twenty
 * seconds would spend requests on a list that changes when a company files a
 * notice, not when a price ticks.
 */
export const useMarketEvents = (query: EventsQuery): UseQueryResult<TablePage<EventRow>> =>
  useQuery<TablePage<EventRow>>({
    ...marketEventsTableQueryOptions(query),
    // A pager click or a filter must not blank the list or collapse the pager to "1"
    // while the next page loads; the previous page stays until it arrives.
    placeholderData: keepPreviousData,
  })
